import Icon from '@/components/snippets/icon/icon'
import { formatMoney } from '@/components/helpers/currency-formatter'
import { PRICE_FILTER_FIELD, RANGE_INDICATOR } from './FilterUtils'
import { globalState } from '@/components/helpers/utils'
import { isSizeFilter, formatUniversalSizeValue } from './SizeFilterUtils'

export function FilterSelected({ activeFilters, onRemove, onClear }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')

    if (field === PRICE_FILTER_FIELD) {
      const [min, max] = value.split(RANGE_INDICATOR)
      const formatMin =
        parseFloat(min) % 1 === 0
          ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals')
          : globalState.shopify.moneyFormat
      const formatMax =
        parseFloat(max) % 1 === 0
          ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals')
          : globalState.shopify.moneyFormat
      return `${formatMoney(parseFloat(min) * 100, formatMin)} ↔ ${formatMoney(parseFloat(max) * 100, formatMax)}`
    }

    if (isSizeFilter(field, value)) {
      return formatUniversalSizeValue(value).replaceAll(RANGE_INDICATOR, '↔')
    }

    return value.replaceAll(RANGE_INDICATOR, '↔')
  }

  return (
    <div className="flex flex-wrap gap-x-1 px-margin py-0.5 border-b border-borders-default">
      {[...activeFilters].map((filter) => {
        return (
          <button className="shrink-0 btn btn-text btn-primary btn-s w-fit whitespace-nowrap" onClick={() => onRemove(filter)} aria-label={`Remove ${formatFilterValue(filter)} filter`}>
            {formatFilterValue(filter)}
            <div className="flex size-[8px] children:size-full">
              <Icon id="close" />
            </div>
          </button>
        )
      })}
      <button className="shrink-0 btn btn-tertiary btn-text btn-s w-fit whitespace-nowrap" onClick={onClear} aria-label="Clear all filters">
        <span className="text-line text-line-large">
          Clear all
        </span>
      </button>
    </div>
  )
}
